<template>
  <div>
    <Form ref="form" :model="queryForm" :label-width="80" inline style="margin-top: 20px">
      <FormItem label="项目名称：" prop="name">
        <Input v-model="queryForm.name" placeholder="输入关键词搜索"></Input>
      </FormItem>
      <FormItem label="帮扶类型：" prop="helpType">
        <Select v-model="queryForm.helpType" style="width: 200px">
          <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="状态：" prop="status">
        <Select v-model="queryForm.status" style="width: 200px">
          <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      <FormItem label="">
        <Button type="primary" style="margin-right: 10px" @click="search">搜索</Button>
        <Button @click="handleResetForm">重置</Button>
      </FormItem>
    </Form>

    <div style="margin-bottom: 20px">
      <Button type="primary" style="margin-right: 10px" @click="editProject(true)">新增</Button>
      <Dropdown @on-click="handleMassOperation" trigger="click">
        <Button type="primary" :disabled="!multiple">
          批量操作
          <i class="ivu-icon ivu-icon-ios-more"></i>
        </Button>
        <template v-slot:list>
          <DropdownMenu>
            <DropdownItem name="audit">批量提交审核</DropdownItem>
            <DropdownItem name="end">批量结束</DropdownItem>
          </DropdownMenu>
        </template>
      </Dropdown>
    </div>

    <Table ref="selection" :columns="columns" :data="data1" @on-selection-change="handleSelectionChange">
      <template v-slot:startTime="{ row, index }">
        {{ formatTime(row.startTime) }}
      </template>
      <template v-slot:endTime="{ row, index }">
        {{ formatTime(row.endTime) }}
      </template>
      <template v-slot:opt="{ row, index }">
        <a v-if="row.status !== -2" style="margin-right: 10px" @click="detailProject(row)">详情</a>
        <a v-else style="margin-right: 10px" @click="detailProject(row)">编辑</a>
        <a style="margin-right: 10px" @click="endProject(row)" v-if="row.status == 3">结束</a>
        <a @click="auditProject(row)" v-if="row.status == 1">提交审核</a>
        <a v-if="row.status === -2" @click="openRefuseDialog(row)">拒绝理由</a>
      </template>
    </Table>

    <div style="display: flex; align-items: center; margin-top: 20px">
      <span style="margin: 0 10px 0 0">总共{{ this.pagination.total }}个项目</span>
      <Page :total="pagination.total" :current="pagination.pageIndex" show-elevator @on-change="handlePageChange" />
    </div>
    <RefuseCommentDialog ref="refuseCommentDialogRef"></RefuseCommentDialog>
  </div>
</template>
<script>
import { Button } from 'iview';
import RefuseCommentDialog from './components/RefuseCommentDialog.vue';
export default {
  props: {
    planId: String
  },
  components: {
    RefuseCommentDialog
  },
  data() {
    return {
      queryForm: {},
      typeList: [
        // {
        //   value: '指导培训',
        //   label: '指导培训'
        // },
        // {
        //   value: '职业介绍',
        //   label: '职业介绍'
        // },
      ],
      ids: [],
      statusList: [
        {
          value: 1,
          label: '未提交'
        },
        {
          value: 2,
          label: '待审核'
        },
        {
          value: 3,
          label: '进行中'
        },
        {
          value: 4,
          label: '已结束'
        },
        {
          value: -2,
          label: '已拒绝'
        }
        // {
        //   value: 3,
        //   label: '已结束'
        // },
      ],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '项目名称',
          key: 'name'
        },
        {
          title: '帮扶类型',
          key: 'helpType'
        },
        {
          title: '状态',
          key: 'statusString'
        },
        {
          title: '参与人数',
          key: 'recoreds'
        },
        {
          title: '获得积分',
          key: 'score'
        },
        {
          title: '开始时间',
          slot: 'startTime'
        },
        {
          title: '结束时间',
          slot: 'endTime'
        },
        {
          title: '操作',
          slot: 'opt',
          width: 160
        }
      ],
      data1: [],
      pagination: {
        total: 32,
        pageIndex: 1,
        pageSize: 10
      },
      multiple: false
    };
  },
  watch: {
    planId: {
      deep: true,
      handler(newVal) {
        this.getList();
      }
    }
  },
  mounted() {
    // this.getList()
    this.getType();
  },
  methods: {
    handleResetForm() {
      this.$refs.form.resetFields();
      this.search();
    },
    getList() {
      this.$axios
        .request({
          url: 'front/v1/company/help-plan-project',
          method: 'get',
          params: { ...this.queryForm, ...this.pagination, planId: this.planId }
        })
        .then(res => {
          if (res.code == 200) {
            this.data1 = res.data.list;
            this.pagination.total = res.data.count;
          }
        });
    },
    getType() {
      this.$axios
        .request({
          url: 'front/v1/help/config',
          method: 'get'
        })
        .then(res => {
          this.typeList = res.data.helpType;
        });
    },
    handlePageChange(page) {
      this.pagination.pageIndex = page;
      // this.handleResetForm()
      this.getList();
    },
    editProject(isAdd = false) {
      if (isAdd) this.$router.push({ name: 'HelpProjectEdit', query: { isAdd: true, planId: this.planId } });
    },
    detailProject(row) {
      this.$router.push({ name: 'HelpProjectDetail', query: { id: row.id } });
    },
    endProject(row) {
      const ids = row ? [row.id] : this.ids;
      const status = 2;
      this.$Modal.confirm({
        title: '是否结束此项目',
        content: '<p>不可恢复，要继续吗？</p>',
        okText: '继续',
        cancelText: '取消',
        onOk: () => {
          this.$axios
            .request({
              url: '/front/v1/company/help-plan-project/review',
              method: 'put',
              data: { ids: ids, status: status }
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getList();
                // this.$router.go(-1);
              }
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    auditProject(row) {
      const ids = row ? [row.id] : this.ids;
      const status = 1;
      this.$Modal.confirm({
        title: '是否提交审核',
        okText: '提交',
        cancelText: '取消',
        onOk: () => {
          this.$axios
            .request({
              url: '/front/v1/company/help-plan-project/review',
              method: 'put',
              data: { ids: ids, status: status }
            })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getList();
                // this.$router.go(-1);
              }
            });
        },
        onCancel: () => {
          // this.$Message.info('Clicked cancel');
        }
      });
    },
    handleMassOperation(name) {
      if (name === 'audit') this.auditProject();
      else if (name === 'end') this.endProject();
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      // console.log(this.ids);
      this.multiple = !!selection.length;
    },
    search() {
      this.pagination.pageIndex = 1;
      this.getList();
    },
    openRefuseDialog(row) {
      this.$refs.refuseCommentDialogRef.open(row);
    }
  }
};
</script>
